import GooglePay from './GooglePay'

export default GooglePay
